<y42-datasource-table-select-list-view
  [hideListViewTitle]="true"
  [hasPadding]="false"
  [multiSelect]="true"
  [selectedIds]="selectedDatasourcePaths"
  (selectionChanged)="selectDatasourceTables($event)"
>
</y42-datasource-table-select-list-view>
